module.exports = __webpack_public_path__ + "img/pantalla-4-5.b1cbc428.png";